import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import { Colors } from '../../config/theme';
import { chaoticOrbit } from 'ldrs';

type SpinnerProps = {
  flexible?: boolean;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  className?: string;
};

const Spinner = ({
  flexible,
  width,
  height,
  style,
  className,
}: SpinnerProps) => {
  chaoticOrbit.register();

  return (
    <>
      {flexible ? (
        <div className={className} style={style}>
          <TailSpin
            color={Colors.primary}
            height={height || 30}
            width={width || 30}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center my-4">
          <l-chaotic-orbit
            size="50"
            speed="1.5"
            color={Colors.greenBright}
          ></l-chaotic-orbit>
        </div>
      )}
    </>
  );
};

export default Spinner;
